import { render, staticRenderFns } from "./CadastroSinalizador.vue?vue&type=template&id=bf9e7e98&"
import script from "./CadastroSinalizador.vue?vue&type=script&lang=js&"
export * from "./CadastroSinalizador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports